import React from 'react';
import '../../styles/breakerPanel.css';

/** Breaker Panel G4: the yellow TEST chip on any record made while its module was in Test. */
export default function TestChip({ className = '', title = 'TEST record — made while this part of the app was in Test' }) {
    return <span className={`ia-test-chip ${className}`.trim()} title={title} data-testid="test-chip">TEST</span>;
}
